
import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className='row'>
            <div className='col-12 d-block d-sm-none d-md-none d-lg-none d-xl-none text-center p-0'>
                <Link to='/'>
                    <img src='/images/logo.svg' alt='logo' className='img-fluid brand-logo' />
                </Link>
            </div>
            <div className='col-12 d-none d-sm-block d-md-block d-lg-block d-xl-block text-left'>
                <div className='row'>
                    <div className='col-6 text-left navbar-brd'>
                        <Link to='/'>
                            <img src='/images/logo.svg' alt='logo' className='img-fluid brand-logo' />
                        </Link>
                    </div>
                    <div className='col-6 d-flex justify-content-end align-items-center'>
                        <ul className='list-unstyled red-links mb-0'>
                            <li>
                                <Link to="/live-deals">
                                    <img src='/images/deals.svg' alt='home' />
                                    Live deals
                                </Link>
                            </li>
                            <li>
                                <Link to="/member-register">
                                    <img src='/images/become-mem.svg' alt='home' />
                                    Become a member
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;